import $ from 'jquery';
import Masonry from 'masonry-layout';
import jQueryBridget from 'jquery-bridget';
import imagesLoaded from 'imagesloaded';
import Instafeed from 'instafeed.js';
import {Loader} from "@googlemaps/js-api-loader";
import '/DistributionPackages/Nexabyte.Site/Resources/Private/JavaScript/slick.min.js';

import {Modal} from "bootstrap";

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');

/**
 * Initialize Slider
 */
$('.slider-container').each(function () {
    if (inBackend) return;
    const $slider = $(this);

    $slider.slick($.parseJSON($(this).attr('data-slick-settings')));


    // Handle sliders if they are "hidden" in a tab element
    const $tabsParent = $slider.closest('.tabs');
    if ($tabsParent.length){
        $tabsParent.find('.tabs-link').on('click', function (e) {
            setTimeout(function () {
                $slider.slick('setPosition');
            }, 100);
        });
    }

});


/**
 * Minimizes the padding of an element in dependency of the scroll position.
 * Typically used for sticky header navs.
 */
$('.scroll-minimizer').each(function () {
    const minimum = 0.3;
    const paddingTop = parseInt($(this).css('padding-top'));
    const paddingBottom = parseInt($(this).css('padding-bottom'));
    const paddingTotal = paddingTop + paddingBottom;
    if (!paddingTotal) return;
    const $minimizerObj = $(this);

    const scrollFunction = function () {
        const scrollRelative = 1 - Math.min($(window).scrollTop() / paddingTotal, 1 - minimum);
        const top = paddingTop * scrollRelative;
        const bottom = paddingBottom * scrollRelative;

        $minimizerObj.css({
            'padding-top': top + 'px',
            'padding-bottom': bottom + 'px',
        });
    };

    $(window).scroll(scrollFunction);
    scrollFunction();
});

/**
 * Scrolls down below the element (self) on click
 */
$('.scroll-down-self').each(function () {

    if (inBackend) return;

    $(this).css('cursor', 'pointer');
    $(this).on('click', function (event) {
        event.preventDefault();

        let offset = 50;
        const dataOffset = $(this).data('scroll-down-offset');
        if (dataOffset !== undefined) {
            offset = parseFloat(dataOffset);
        }

        $('html, body').animate({
            scrollTop: $(this).position().top + $(this).outerHeight(true) - offset,
        }, 450);

    });
});

/**
 * Add Masonry-Grid and preload images
 */
jQueryBridget('masonry', Masonry, $);
jQueryBridget('imagesLoaded', imagesLoaded, $);

var $grid = $('.masonry').masonry({
    itemSelector: '.masonry-item',
    columnWidth: '.masonry-item',
    transitionDuration: 3,
    percentPosition: true,
    horizontalOrder: true,
});

// layout Masonry after each image loads
$grid.imagesLoaded(function () {
    $grid.masonry('layout');
});


/**
 * Instafeed
 */
$('#instafeed').each(function () {
    const $consentElement = $(this).find('.consent');
    const $instafeedElement = $(this).find('.instafeed-element');

    $consentElement.on('click', function () {
        const token = $instafeedElement.attr('data-instafeed-token') || '';
        const limit = parseInt($instafeedElement.attr('data-instafeed-limit')) || 1;
        const target = $instafeedElement.attr('id');

        const feed = new Instafeed({
            accessToken: token,
            limit: limit,
            target: target,
            template: '<div class="instapost"><img src="{{image}}" /><div class="instacaption">{{caption}}</div><a class="btn bg-blue" href="{{link}}" target="_blank">Zum Post</a></div>'
        });
        feed.run();
        $consentElement.parent().remove();

    });
});

/**
 * Video-Player add button and hide it on play
 *
 */
$('.video').each(function () {
    let $video = $(this).find('video');
    let $button = $(this).find('.play-button');
    let $poster = $(this).find('.poster');

    $button.on('click', function () {
        $video[0].play();
        $button.hide();
        $poster.hide();
    });

    $video.on('play', function () {
        $button.hide();
        $poster.hide();
    });

    $video.on('pause', function () {
        $button.show();
    });
});

//
// /**
//  * Smooth scroll anchor clicks
//  */
// $("a").each(function () {
//
//
//     if (inBackend) return;
//
// // Return if no hash was found
//     const hash = this.hash;
//     if (!hash) return;
//
// // Get href without hash
//     const href = this.href.replace(this.hash, "");
//
// // Get current uri without hash
//     const uri = window.location.href.split("#")[0];
//
// // Check if link leads to another page. Abort if.
//     if (uri !== href) return;
//
// // Find target and add scroll behaviour
//     const $target = $(hash);
//     if ($target.length) {
//         $(this).on("click", function (event) {
//             event.preventDefault();
//
//             $('html, body').animate({
//                 scrollTop: $target.offset().top - 160
//             }, 600);
//         });
//     }
// });


/**
 * Open external links in new window
 */
$("a").filter('[href^="http"], [href^="https"], [href^="//"]')
    .not('[href*="' + window.location.host + '"]')
    .attr('rel', 'noopener noreferrer')
    .attr('target', '_blank')
    .addClass("external-link");


/**
 * Prevent links to be clickable in backend
 */
if (inBackend) {
    $('.neos-backend main a, .neos-backend main button, .neos-backend footer a, .neos-backend footer button').click(function (event) {
        event.preventDefault();
    });
}

/**
 * Open Modal on click
 */
$('a').each(function () {
    const href = $(this).attr('href');
    if (!href) return;
    if (!href.startsWith("popup:")) return;
    const targetId = href.replace("popup:", "");
    const $target = $('#' + targetId);
    if (!$target.length) return;
    const modal = new Modal($target);
    $(this).on('click', function (event) {
        event.preventDefault();
        modal.show();
    });
});



/**
 * Open external links in new window
 */
$("a").filter('[href^="http"], [href^="https"], [href^="//"]')
    .not('[href*="' + window.location.host + '"]')
    .attr('rel', 'noopener noreferrer')
    .attr('target', '_blank')
    .addClass("external-link");




/**
 * Google Maps Options
 */
$('.google-map').each(function () {

    let $mapElement = $(this);
    let $consentElement = $(this).find('.consent');
    let lat = parseFloat($mapElement.attr('data-maps-lat'));
    let lng = parseFloat($mapElement.attr('data-maps-lang'));
    let zoom = parseInt($mapElement.attr('data-maps-zoom'));
    let icon = $mapElement.attr('data-maps-src');
    let title = $mapElement.attr('data-maps-title');
    let text = $mapElement.attr('data-maps-text');
    let apiKey = $mapElement.attr('data-maps-api-key');
    let scriptsrc = $mapElement.attr('data-maps-scriptsrc');
    let map;
    var myLatLng = {lat: lat, lng: lng};
    var contentString = '<h4>' + title + '</h4><p>' + text + '</p>';

    const loader = new Loader({
        apiKey: apiKey,
        version: "weekly",
    });


    $consentElement.on('click', function () {
        var mapProp = {
            center: myLatLng,
            zoom: zoom,
            streetViewControl: false,
            mapTypeControl: false,
            zoomControl: true,
            styles: [
                {
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#616161"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#1c1c4e"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#bdbdbd"
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#e0e8f5"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#757575"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#757575"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dadada"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#616161"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#929292"
                        }
                    ]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#c9c9c9"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#6d8bc5"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#10edaa"
                        }
                    ]
                }
            ]

        };

        loader.load().then(() => {
            map = new google.maps.Map($mapElement[0], mapProp);
        });

        if (icon.lenght > 0) {
            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: {
                    url: icon
                },

            });
        }

        if (contentString.lenght > 0) {
            var infowindow = new google.maps.InfoWindow({
                content: contentString
            });

            infowindow.open(map, marker);
        }
    });
    // document.getElementsByTagName("head")[0].appendChild(script);
});
